import React, { useState } from "react";
import { convertTimeIntoHourMin, getRole } from "../utils/generic";
import styled from "styled-components";
import { getUUID } from "../../utils";
import { localStore } from "../../../../../helpers";
import { changeLastAssistMessage } from "../../../../../dialpad/service/chat.service";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { chatAction, messageAction } from "../../../../../store/action";
import { connect } from "react-redux";

const MessageMultiChoice = styled.div`
  max-width: 480px;
  .buttonStyle {
    // border: 0.5px solid #1b255924;
    background: #28a6de;
    color: #fff;
    border-radius: 20px;
    /* font-family: Plus Jakarta Sans; */
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    cursor: default;
    opacity: 1 !important;
  }
`;

const MultiChoice = ({ message, ...props }) => {
  const [isOptionClicked, setIsOptionClicked] = useState(false);
  const sendMessage = (text) => {
    if (!text) return;
    setIsOptionClicked(true);

    const {
      configProcessor,
      assistMessages,
      currentUser,
      selectedAssignedList,
      dynamicUpdate,
    } = props;

    const messagePayload = {
      from: "customer",
      timeStamp: new Date().toISOString(),
      type: 'text',
      plateform: "agent-assist",
      content: { text },
      id: getUUID(),
    };

    const messageData = {
      userId: currentUser.userId,
      timeStamp: new Date().toISOString(),
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      message: messagePayload,
    };

    configProcessor("sendPayload", {
      tenantId: localStore.getItem('selected-tenant'),
      customerIdentifier: selectedAssignedList && selectedAssignedList.identifier,
      customerSessionId: selectedAssignedList && selectedAssignedList.sessionId,
      teamId: selectedAssignedList.teamId,
      teamName: selectedAssignedList.teamName,
      identifier: `AGENT-ASSIST-SESSION:${currentUser.userId}:${selectedAssignedList && selectedAssignedList.sessionId}`,
      payloadType: 'message',
      "rmq:pattern": "agent:assist:message",
      id: messagePayload.id,
      message: {
        ...(selectedAssignedList && selectedAssignedList.message || {}),
        ...messagePayload,
      },
    });

    changeLastAssistMessage({
      list: assistMessages,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assistMessageList",
    });

    const identifier = `AGENT-ASSIST-SESSION:${currentUser.userId}:${selectedAssignedList && selectedAssignedList.sessionId}`;
    dynamicUpdate({
      data: {
        key: `assistMessageList.${identifier}`,
        value: [messageData, ...(assistMessages || [])],
      },
    });
  };

  if (message && message.content) {
    return (
      <MessageMultiChoice>
        <p className="msg" style={{ whiteSpace: "pre-wrap" }}>
          {message.content.text}
        </p>

        {message.content.options &&
          message.content.options.map((option, index) => {
            return (
              <button
                key={index}
                className={`btn btn-outline-primary m-1 flex-grow-1 buttonStyle`}
                disabled={isOptionClicked}
                onClick={() => sendMessage(option.title)}
              >
                {option.title || ""}
              </button>
            );
          })}
        {/* <div className="message-info-td">
          <span className="message-time">{convertTimeIntoHourMin(message.timeStamp)}</span>
          <span className="material-symbols-outlined message-deliver">done_all</span>
        </div> */}
      </MessageMultiChoice>
    );
  } else {
    return <div></div>;
  }
};

const stateToProps = (state) => {
  // Fetch the required state properties first
  const selectedAssignedList = chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  );
  const currentUser = globalStateSelector.getDynamic(state, { key: "currentUser" });

  const identifier = `AGENT-ASSIST-SESSION:${currentUser.userId}:${selectedAssignedList.sessionId}`;


  return {
    selectedAssignedList,
    currentUser,
    showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
    chatAgentAssist: chatSelector.getChatAgentAssist(state),
    loadingAssistMsg: chatSelector.getLoadingAgentAssistStatus(state),
    chatChecklist: chatSelector.getChatDynamic(state,
      `chatChecklist_${selectedAssignedList.sessionId}`
    ) || [],
    agentAssistReply: chatSelector.getChatDynamic(state, `agentAssistReply_${selectedAssignedList.sessionId}`),
    showAgentAssistMsg: chatSelector.getChatDynamic(state, `showAgentAssistMsg_${identifier}`),
    activeTabRight: chatSelector.getActiveTabRight(state),

    assistMessages: chatSelector.getChatDynamic(state, `assistMessageList.${identifier}`) || [],
    typingAssistCus: chatSelector.getAgentTypingStatus(
      state,
      identifier || null
    ),
    assistPaginationInfo: chatSelector.getChatDynamic(state, "assistPaginationInfo"),
  };
};

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});

export default connect(stateToProps, dispatchToProps)(MultiChoice);


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/MultiChoice.jsx